import axios from 'axios';
import {backendHost} from '../../config';

export const deleteUsers = (params) => {
    return axios.delete(`${backendHost}/api/admin/v2/mailing/users`, {params});
};